import React from "react";
import cx from "classnames";
import { Icon } from "components/Icon/Icon";
import { TranslateWrapper } from "components/TranslateWrapper";
import type { TranslateWrapperProps } from "interfaces/shared.types";
import type * as Scrivito from "scrivito";

import s from "./LeftSidebar.module.scss";

type LeftSidebarSubNavHeaderProps = {
  isFinalSubNav?: boolean;
  title?: string | { props: TranslateWrapperProps };
  referenceObj: Scrivito.Obj;
  subtitle?: string;
};

export const LeftSidebarSubNavHeader = ({
  isFinalSubNav = false,
  title,
  referenceObj,
  subtitle = undefined,
  ...rest
}: LeftSidebarSubNavHeaderProps) => {
  const TitleType = isFinalSubNav ? "h3" : "h4";
  const SubtitleType = isFinalSubNav ? "h6" : "span";
  const translatedTitle = typeof title === "object" ? title.props.text : title;
  const titleMenu =
    translatedTitle ||
    (referenceObj?.get("menuTitle") as string) ||
    (referenceObj?.get("title") as string);
  const subTitle =
    subtitle ||
    (referenceObj?.get("menuSubtitle") as string) ||
    (referenceObj?.get("subtitle") as string) ||
    "";

  const subnavTitle = (
    <TitleType
      className={cx("title text-uppercase mb-0", s.leftSidebarSubNavLinkTitle)}
    >
      {titleMenu}
    </TitleType>
  );

  const toolTip =
    typeof title === "object" ? (
      <TranslateWrapper
        text={titleMenu}
        tooltipText={title.props.tooltipText}
        tooltipId={null}
      />
    ) : null;

  return (
    <div className="d-flex flex-column gap-1" {...rest}>
      <div className="d-flex gap-2">
        {isFinalSubNav && (
          <Icon iconName="TROX-Ox_Logo-onlyOX" className="icon-32" />
        )}

        {typeof title === "object" ? toolTip : subnavTitle}
      </div>
      {subTitle && (
        <SubtitleType
          className={cx("fw-normal mb-0", s.leftSidebarSubNavLinkSubtitle, {
            font16: !isFinalSubNav,
            "text-gray-500 uppercase": isFinalSubNav,
          })}
        >
          {subTitle}
        </SubtitleType>
      )}
    </div>
  );
};
